var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSentimentSatisfied(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 .75C9.369.75.75 9.369.75 20S9.369 39.25 20 39.25 39.25 30.631 39.25 20 30.631.75 20 .75zm-5.81 13.261a2.25 2.25 0 10.002 4.5 2.25 2.25 0 00-.001-4.5zm9.394 2.25a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM20 3.25c9.25 0 16.75 7.5 16.75 16.75S29.25 36.75 20 36.75 3.25 29.25 3.25 20 10.75 3.25 20 3.25zm7.192 21.558a1.25 1.25 0 00-1.754-.218A8.808 8.808 0 0120 26.466a8.806 8.806 0 01-5.438-1.875 1.25 1.25 0 00-1.537 1.971A11.306 11.306 0 0020 28.966c2.558 0 4.988-.856 6.974-2.403a1.25 1.25 0 00.218-1.755z",
    fill: "#9E9E9E"
  })));
}

export default SvgSentimentSatisfied;